<div class="form-modal">
    <h1 mat-dialog-title>{{'GUIDELINES'| translate}}</h1>
    <div mat-dialog-content>
      <div class="row">
  
        <div class="col-sm-12">
          <div class="row no-margin-top">
  
            <div class="col-sm-12">
              <div class="panel panel-default">
                <div class="panel-body no-horizontal-padding">
  
                  <div class="form-group">
  
                    <div class="col-sm-12" *ngIf="texto && idImagem">
                      <div class="col-sm-12">
                        {{texto}}
                      </div>
                      <div class="col-sm-12">
                        <img [src]="defaultImage.FileContent" 
                        alt="Exemplo Imagem">
                      </div>
                    </div>
                    <div class="col-sm-12" *ngIf="texto && idImagem == null">
                        {{texto}}
                    </div>
                    <div class="col-sm-12" *ngIf="texto == null && idImagem">
                      <img 
                       [src]="defaultImage.FileContent" style="max-width: 100%; max-height: 75%;" alt="Exemplo Imagem">
                  </div>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
  
      </div>
    </div>
    <div mat-dialog-actions>    
      <div class="full-width text-right">
        <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(false)">
          {{'CLOSE' | translate}}
        </button>
      </div>
    </div>
  </div>